import actions from 'actions';
import { FAILED_API_REQUEST_PREFIX } from 'constants/Global';
import { translate } from 'helpers/Translate';

/**
 * Errors' reducer.
 * @param {String} state  Existing Errors' state
 * @param {Object} action Action dispatched
 * @return {Object} New state
 */
export default (state = null, action) => {
    if (action.type.startsWith(FAILED_API_REQUEST_PREFIX) || action.type === actions.SET_ERROR) {
        console.error(action.error); // eslint-disable-line no-console
        return {
            ts: new Date().getTime(),
            content: translate('Une erreur technique est survenue, veuillez réessayer plus tard'),
            raw: action.error,
        };
    }
    if (action.type === actions.CLEAR_ERROR) {
        return null;
    }
    return state;
};
